/**
 * @generated SignedSource<<ded6412d4afa0567c1802c017b38248b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTable_sheet$data = {
  readonly columns: ReadonlyArray<{
    readonly label: string;
  }>;
  readonly sections: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_section">;
  }>;
  readonly title: string | null;
  readonly " $fragmentType": "WidgetTable_sheet";
};
export type WidgetTable_sheet$key = {
  readonly " $data"?: WidgetTable_sheet$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_sheet">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTable_sheet",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetTableColumn",
      "kind": "LinkedField",
      "name": "columns",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetTableSection",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTable_section"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTableSheet",
  "abstractKey": null
};

(node as any).hash = "8bf0756575151b5c3adcbb4f3088206e";

export default node;
